import React from 'react'
import { Box, Typography } from '@material-ui/core'
import useStyles from './styles'

const ProgressBars = ({ info }) => {
  const classes = useStyles()

  const array = Object.entries(info).map(([clave, valor]) => ({ clave, valor }))
  const formatedInfo = array
    .filter(
      (item) =>
        item.clave !== 'total' &&
        item.clave !== 'rol' &&
        item.clave !== 'finalizado',
    )
    .map((item) => {
      // const percent = item.clave === info.rol.toLowerCase() ? (info.total / item.valor) * 100 : (item.valor / info.total) * 100;
      const percent = (item.valor / info.total) * 100
      return { ...item, percent }
    })

  const order = ['baseline', 'category', 'gerente', 'sincronizacion', 'junta']

  const compare = (a, b) => order.indexOf(a.clave) - order.indexOf(b.clave)

  const sortedArray = formatedInfo.sort(compare)
  return (
    <>
      {info.rol === null ? (
        <Typography>Aún no tienes un rol asignado</Typography>
      ) : (
        <>
          <Typography className={classes.title}>Barras de progreso</Typography>
          <Box className={classes.barsContainer}>
            {sortedArray.map((item) => (
              <>
                {item.clave !== 'rol_id' && (
                  <Box className={classes.barContainer}>
                    {item.clave === info.rol.toLowerCase() && (
                      <p className={classes.titleTotal}>{info.total}</p>
                    )}
                    {item.clave === 'baseline' ? (
                      <Box className={classes.bar}>
                        <Box
                          className={classes.barColor}
                          style={{ height: '100%' }}
                        />
                        <div className={classes.infoContainer}>
                          <p
                            style={{
                              fontWeight: 'bold',
                            }}
                          >
                            {item.valor}
                          </p>
                        </div>
                      </Box>
                    ) : (
                      <Box className={classes.bar}>
                        <Box
                          className={classes.barEmpty}
                          style={{ height: `${100 - item.percent}%` }}
                        />
                        <Box
                          className={
                            item.clave === info.rol.toLowerCase()
                              ? classes.barColorSelected
                              : classes.barColor
                          }
                          style={{ height: `${item.percent}%` }}
                        />
                        <div className={classes.infoContainer}>
                          <p
                            style={{
                              fontWeight: 'bold',
                            }}
                          >
                            {item.valor}
                          </p>
                        </div>
                      </Box>
                    )}
                    <p className={classes.barTitle}>{item.clave}</p>
                  </Box>
                )}
              </>
            ))}
          </Box>
        </>
      )}
    </>
  )
}

export { ProgressBars }
